module.exports = __webpack_public_path__ + "static/media/FattyPay.62cbc00d.svg";